export default __webpack_public_path__ + "static/media/calendly-logo.f3295db8.svg";